import { authSplitApi } from 'redux/helpers/slice.helpers';
import { ETemplateTypeUI, THPDocResponse } from 'data/types/document.types';
import { templateTypeConvertor } from 'data/converters/docPacket.convertors';
import { TTenantAnimals } from 'data/types/tenant.types';

export const COMMON_BASE_URL = `common/api/v2`;

export const commonApi = authSplitApi('commonApi', []).injectEndpoints({
  endpoints: (build) => ({
    getTemplate: build.mutation<THPDocResponse, ETemplateTypeUI>({
      query(templateType) {
        return {
          url: `${COMMON_BASE_URL}/application-sample-template/search`,
          method: 'GET',
          params: { docType: templateTypeConvertor.toDb(templateType) },
        };
      },
    }),
    getTenantAnimals: build.query<TTenantAnimals[], string>({
      query(tenantId) {
        return {
          url: `${COMMON_BASE_URL}/tenant/${tenantId}/animals`,
          method: 'GET',
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetTemplateMutation, useGetTenantAnimalsQuery } = commonApi;
